<ngx-spinner
  bdColor="rgba(9, 37, 23, 0.96)"
  size="medium"
  color="#ffffff"
  type="ball-scale-multiple"
  [fullScreen]="true"
>
</ngx-spinner>